import { Locale } from "./types/locale";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";

/**
 * Self-contained locale handler. Grabs all locales from the server in the constructor
 * to be accessed by other modules.
 */
export default class LocaleHandler extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected localeList: Locale[] = [];

    constructor(vnAppZone: vnAppZone, idBrand: number) {
        super(vnAppZone);
        this.initLocales(idBrand);
    }

    public getLocale = function (id: number): Locale | null {
        return this.localeList[id] || null;
    }

    public getLocaleByCountryCode = function (cc: string): Locale | null {
        if (!cc) {
            return null;
        }
        let locale = this.localeList.filter((locale) => locale.countryCode.toLowerCase() == cc.toLowerCase());
        if (locale.length > 0) {
            return locale[0];
        } else {
            return null;
        }
    }

    public initLocales = function (idBrand): void {
        let localeUrl: string = '/api/brand/' + idBrand + '/locales';

        this.XHRHdl = new XMLHttpRequestHandler(localeUrl, [], this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.XHRHdl.onReadyStateFunction = this.setLocales;
        this.XHRHdl.execute();
    }

    public locales = () => !!this.localeList && this.localeList;

    private setLocales(req, self): Function {
        return function () {
            self.manageResponse(req, self, function () {

                let response = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    const localeList: Array<Locale> = response.data;
                    localeList.map((localeData) => self.localeList[localeData.id] = localeData);
                } else {
                    console.error('could not load locales');
                }
            });
        }
    }

    protected getModuleName(): string {
        return 'LocaleHandler';
    }

    /**
     * Nothing to build here.
     *
     * @returns array
     */
    public buildContent(): Element[] {
        return [];
    }
}



// WEBPACK FOOTER //
// ./js/utils/LocaleHandler.ts